import React from 'react'
import styles from './logo.module.css'
import logo from '../../images/logo.svg'

const Logo = () => {
  return (
    <div className={styles.logo}>
      <img src={logo} alt="Full Stack Developer Logo" width="50"/>
    </div>
  )
}

export default Logo
